import React, { FC, useEffect, useState } from 'react';
import { FindingTypeProperty, FindingTypePropertyRepresentation } from '../AnnotationStandardForm.slice';
import { Input, Select, Checkbox } from 'antd';
import { getInitialShowValue } from '../helpers';

type Props = {
  property: FindingTypeProperty;
  representation: FindingTypePropertyRepresentation | undefined;
  canEdit: boolean;
  onRowChanged: (
    id: string,
    representationId: string | undefined,
    title: string,
    unit: string,
    group: string,
    mandatory: boolean,
    show: boolean
  ) => void;
};

const FindingTypePropertiesRow: FC<Props> = ({ property, representation, canEdit, onRowChanged }) => {
  const [title, setTitle] = useState<string>(() => {
    return representation ? representation.title : property.fullName;
  });
  const [unit, setUnit] = useState<string>(() => {
    return representation ? representation.unit : '';
  });
  const [group, setGroup] = useState<string>(() => {
    return representation ? representation.group : '';
  });
  const [mandatory, setMandatory] = useState<boolean>(() => {
    return representation ? representation.isMandatory : false;
  });
  const [show, setShow] = useState<boolean>(() => {
    return representation ? representation.show : getInitialShowValue(property.name);
  });

  useEffect(() => {
    if (representation && representation.group) {
      setGroup(representation.group);
    }
  }, [representation]);

  const rowChanged = (newTitle: string, newUnit: string, newGroup: string, newMandatory: boolean, newShow: boolean) => {
    onRowChanged(property.id, representation ? representation.id : undefined, newTitle, newUnit, newGroup, newMandatory, newShow);
  };

  const handleChange = (value: string) => {
    setUnit(value);
    rowChanged(title, value, group, mandatory, show);
  };

  return (
    <tr>
      <td>{property.name}</td>
      <td>
        <Input
          disabled={!canEdit}
          placeholder='Enter Title'
          value={title}
          onChange={e => {
            setTitle(e.target.value);
            rowChanged(e.target.value, unit, group, mandatory, show);
          }}
        />
      </td>
      <td>
        <Select disabled={!canEdit} style={{ width: 120 }} onChange={handleChange} value={unit}>
          {property.units &&
            property.units
              .split(',')
              .map(x => x.trim())
              .map(x => (
                <Select.Option key={x} value={x}>
                  {x}
                </Select.Option>
              ))}
        </Select>
      </td>
      <td>
        <Input
          disabled={!canEdit}
          placeholder='Enter Group'
          value={group}
          onChange={e => {
            setGroup(e.target.value);
            rowChanged(title, unit, e.target.value, mandatory, show);
          }}
        />
      </td>
      <td>
        <Checkbox
          disabled={!canEdit}
          checked={mandatory}
          onChange={e => {
            setMandatory(e.target.checked);
            rowChanged(title, unit, group, e.target.checked, show);
          }}
        />
      </td>
      <td>
        <Checkbox
          disabled={!canEdit}
          checked={show}
          onChange={e => {
            setShow(e.target.checked);
            rowChanged(title, unit, group, mandatory, e.target.checked);
          }}
        />
      </td>
    </tr>
  );
};

export default FindingTypePropertiesRow;
